import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/axiosConfig";

const optionClass = (question, optionId) => {
  if (optionId === question.correct) return " is-correct";
  if (optionId === question.selected) return " is-wrong";
  return "";
};

function TestAnalysis() {
  const { courseId, kind, testId } = useParams();
  const [review, setReview] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    api
      .get(`/learn/${courseId}/tests/${kind}/${testId}/analysis`)
      .then((res) => {
        if (!cancelled) setReview(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.message || "Analysis not available.");
      });
    return () => {
      cancelled = true;
    };
  }, [courseId, kind, testId]);

  if (!review && !error) return <p className="text-center py-5">Loading analysis...</p>;
  if (!review?.score) {
    return (
      <main className="section-space">
        <div className="container">
          <p>{error}</p>
          <Link to={`/my-courses/${courseId}`}>Back to course</Link>
        </div>
      </main>
    );
  }

  const { test, score, questions } = review;
  const base = `/my-courses/${courseId}/tests/${kind}/${testId}`;

  return (
    <main className="exam-page section-space">
      <div className="container">
        <p className="my-course-back">
          <Link to={`/my-courses/${courseId}`}>← Back to course</Link>
        </p>
        <header className="exam-top">
          <div>
            <p className="learn-kicker">Analysis</p>
            <h1>{test.title}</h1>
            <p>
              Score {score.marks} of {score.maxMarks}. {score.correct} correct, {score.wrong} wrong,{" "}
              {score.skipped} skipped.
            </p>
          </div>
          <Link className="btn-view-course" to={base}>
            Re-attempt
          </Link>
        </header>

        <div className="analysis-list">
          {questions.map((question, index) => (
            <article key={question.id} className={`analysis-card is-${question.status}`}>
              <p className="learn-kicker">
                Question {index + 1} · {question.status}
              </p>
              <div className="exam-question" dangerouslySetInnerHTML={{ __html: question.question }} />
              <div className="exam-options">
                {question.options.map((option) => (
                  <div key={option.id} className={`exam-option${optionClass(question, option.id)}`}>
                    <span>{option.id}</span>
                    <span dangerouslySetInnerHTML={{ __html: option.text }} />
                  </div>
                ))}
              </div>
              {question.explanation ? (
                <div className="analysis-note">
                  <strong>Explanation</strong>
                  <div dangerouslySetInnerHTML={{ __html: question.explanation }} />
                </div>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </main>
  );
}

export default TestAnalysis;
